import adminApi from "../../api";

class AdminCategoryService {
  async getAllCategories() {
    const response = await adminApi.get("/categories");
    return response.data;
  }

  async createCategory(name) {
    const response = await adminApi.post("/categories", { name });
    return response.data;
  }

  async updateCategory(id, name) {
    const response = await adminApi.put(`/categories/${id}`, { name });
    return response.data;
  }

  async deleteCategory(id) {
    const response = await adminApi.delete(`/categories/${id}`);
    return response.data;
  }
}

export default new AdminCategoryService();
